<template>
  <page-table :current-page.sync="currentPage" :per-page.sync="perPage" :subtitle="subtitle" :title="title"
              :total-rows="totalRows">
    <template v-slot:filter>
      <status-filter :status-list="statusList" v-model="filter"/>
    </template>
    <template v-slot:table>
      <b-table :busy="busy" :current-page="currentPage" :fields="fields" :filter="filter"
               :filter-included-fields="filterOn"
               :items="audits" :per-page="perPage" :sort-by="sortBy" :sort-desc="sortDesc"
               :sort-direction="sortDirection" @filtered="onFiltered" striped tbody-tr-class="rowClass">
        <template #cell(status)="data">
          <status :status="data.value"/>
        </template>
        <template #cell(auditing_org)="data">
          <address-book-by-public-key :public-key="data.value"/>
        </template>
        <template #cell(audit_creator)="data">
          <address-book-by-public-key :public-key="data.value"/>
        </template>
        <template #cell(created_at)="data">
          {{ data.value | timeline }}
        </template>
        <template #cell(proposal_id)="data">
          <a @click="getProposal(data.value)" href="javascript:void(0)">Proposal details</a>
        </template>
        <template #cell(actions)="data">
          <i @click="viewAudit(data.item)" class="text-dark-green font-18 fa fa-border fa-eye" style="cursor: pointer"
             title="View Audit"/>
          <i @click="storeAuditId(data.item.audit_id)" class="text-danger ml-1 font-18 fa fa-border fa-trash-alt"
             data-target="#deleteModal"
             data-toggle="modal" style="cursor: pointer" title="Delete Audit"
             v-if="data.item.status === 'Requested' && data.item.audit_creator === activeGroup.anonymous_account"/>
        </template>
        <template #table-busy>
          <div class="text-center  my-5">
            <b-spinner class="align-middle"/>
          </div>
        </template>
      </b-table>
    </template>
    <template v-slot:modals>
      <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="deleteModal" role="dialog"
           tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel1">Are you sure you want to delete this audit?</h4>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label class="control-label" for="message-text">Comments:</label>
                  <textarea class="form-control" id="message-text1" v-model="comments"></textarea>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button :disabled="isDeleted" @click="deleteAudit"
                      class="btn waves-effect waves-light btn-success"
                      type="button">
                <span v-if="!isDeleted">Yes</span>
                <span v-if="isDeleted"><i class="fa fa-spinner fa-spin"/> &nbsp;Loading</span>
              </button>
              <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <proposal-stat :proposal="proposal"/>
    </template>
  </page-table>
</template>

<script>
  import Status from '@/components/protected/common/Status.vue';
  import StatusFilter from '@/components/protected/common/StatusFilter.vue';
  import {mapGetters} from 'vuex';
  import AddressBookByPublicKey from '@/components/protected/common/AddressBookByPublicKey.vue';
  import ProposalStat from '@/components/protected/common/ProposalStat.vue';
  import PageTable from '@/components/protected/PageTable.vue';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'AuditList',
    mixins: [apiMixin('audit')],
    components: {ProposalStat, AddressBookByPublicKey, Status, StatusFilter, PageTable},
    props: {
      audits: {type: Array, required: true},
      title: {type: String, required: true},
      subtitle: {type: String, required: true},
      busy: {type: Boolean, required: true}
    },
    data() {
      return {
        fields: [
          {
            key: 'audit_id',
            label: 'Audit ID',
            sortable: true
          },
          {
            key: 'status',
            sortable: true
          },
          {
            key:
              'certification_name',
            label: 'Certification',
            sortable: true
          },
          {
            key: 'auditing_org',
            label: 'Auditor',
            sortable: true
          },
          {
            key: 'audit_creator',
            label: 'Initiator',
            sortable: true
          },
          {
            key: 'proposal_id',
            label: 'Transaction'
          },
          {
            key: 'actions'
          }
        ],
        auditors: [],
        del_audit_id: null,
        status: null,
        isDeleted: false,
        proposal: null,
        currentPage: 1,
        filter: '',
        filterOn: ['status'],
        sortBy: 'audit_id',
        sortDesc: false,
        sortDirection: 'asc',
        perPage: 5,
        totalRows: 0,
        statusList: ['Requested', 'Accepted', 'Completed'],
        comments: null
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'publicKey', 'activeGroup'])
    },
    watch: {
      audits(value) {
        this.totalRows = value.length;
      }
    },
    methods: {
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      viewAudit(audit) {
        if (audit.status === 'Requested' && audit.auditing_org === this.activeGroup.anonymous_account) {
          this.$router.push({name: 'acceptaudit', params: {auditId: audit.audit_id}});
        } else {
          this.$router.push({name: 'viewaudit', params: {auditId: audit.audit_id}});
        }
      },
      storeAuditId(auditId, status) {
        this.del_audit_id = auditId;
        this.status = status;
      },
      async deleteAudit() {
        $('#deleteModal').modal('toggle');
        this.isDeleted = true;
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit Deleted', async () => {
          await this.$api.delete(`/audits/${this.del_audit_id}`, {
            data: {
              comments: this.comments
            }
          });
        })
        this.reset();
        await this.$parent.getAudits();
        this.isDeleted = false;
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
      },
      reset() {
        this.del_audit_id = null;
        this.status = null;
      },
      async getProposal(proposal_id) {
        this.proposal = null;
        try {
          // TODO: improve code
          const {data} = await this.$api.get(`/groups/proposals/${proposal_id}`);
          const yes_voters = data.votes.ayes.map(y => y[0]);
          const no_voters = data.votes.nays.map(n => n[0]);
          if (yes_voters.includes(this.publicKey)) {
            data.status = 'Approved';
          } else if (no_voters.includes(this.publicKey)) {
            data.status = 'Rejected';
          } else {
            data.status = 'Pending';
          }
          this.proposal = data;
          this.proposal.voters = yes_voters;
        } catch (e) {
          console.error(e);
        } finally {
          $('#proposalModal').modal('toggle');
        }
      }
    }
  }
</script>

<style>
  .rowClass td {
    vertical-align: middle;
  }
</style>
